import { render, staticRenderFns } from "./form_customer.vue?vue&type=template&id=18f48c0f&scoped=true"
import script from "./form_customer.vue?vue&type=script&lang=js"
export * from "./form_customer.vue?vue&type=script&lang=js"
import style0 from "./form_customer.vue?vue&type=style&index=0&id=18f48c0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f48c0f",
  null
  
)

export default component.exports